import React from "react";
import { connect } from "react-redux";
import { PageHeader } from "antd";
import RackAcomodo from "./RackAcomodo";

const AcomodoRackPagina = ({ history, empresaId, proyectoId, rackId, headersToken, permisoAgregarUbicacion, permisoDeshabilitarUbicacion }) => {
  if (!rackId || !proyectoId) {
    return (
      <PageHeader
        title="Acomodo de rack"
        onBack={() => history.goBack()}
        style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white" }}
        subTitle="Falta información del rack. Vuelve al mapa y ábrelo desde ahí."
      />
    );
  }

  return (
    <>
      <PageHeader
        title="Acomodo de rack"
        onBack={() => history.goBack()}
        style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white", marginBottom: 10 }}
      />
      <div style={{ background: "#fff", borderRadius: 14, padding: 16 }}>
        <RackAcomodo
          rackId={rackId}
          empresaId={empresaId}
          proyectoId={proyectoId}
          headersToken={headersToken}
          permisoAgregarUbicacion={permisoAgregarUbicacion}
          permisoDeshabilitarUbicacion={permisoDeshabilitarUbicacion}
          activo
          enPagina
        />
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  proyectoId: ownProps.location?.state?.proyectoId,
  rackId: ownProps.location?.state?.rackId,
  permisoAgregarUbicacion:
    state.user.tipo === 0 ||
    state.user.permisos.find((v) => v.permisoId.toString() === "6a5408afe00cff7ab4c38913")?.activado,
  permisoDeshabilitarUbicacion:
    state.user.tipo === 0 ||
    state.user.permisos.find((v) => v.permisoId.toString() === "6a5408e0e00cff7ab4c38916")?.activado,
});

export default connect(mapStateToProps)(AcomodoRackPagina);
